import { Component, Inject, OnDestroy, OnInit, ChangeDetectorRef, ViewChild, AfterViewInit } from '@angular/core';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { FinancRp } from '../../../../../shared/interfaces/financ-rp';
import { FinancRpService } from '../../../../../shared/services/financ-rp.service';
import { FatDoctoC } from '../../../../../shared/interfaces/fat-docto-c';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';

import * as moment from 'moment';
import { Portador } from '../../../../../shared/interfaces/portador';
import { TipoCobranca } from '../../../../../shared/interfaces/tipo-cobranca';
import { PortadorService } from '../../../../../shared/services/portador.service';
import { TipoCobrancaService } from '../../../../../shared/services/tipo-cobranca.service';
import { PageResult } from '../../../../../shared/interfaces/page-result';
import { Observable, ReplaySubject, Subject, forkJoin, of } from 'rxjs';
import { debounceTime, tap, switchMap, takeUntil } from 'rxjs/operators';
import { FinancRpPopupComponent } from '../../../../../../app/views/movimentacao/financeiro/financ-rp/financ-rp-popup/financ-rp-popup.component';
import { LayoutService } from '../../../../../shared/services/layout.service';
import { FatDoctoCService } from '../../../../../shared/services/fat-docto-c.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';

@Component({
  selector: 'app-lancamento-parcelas',
  templateUrl: 'lancamento-parcelas.component.html',
  styleUrls: ['lancamento-parcelas.component.scss'],
})
export class LancamentoParcelasComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('ngxDatatable') ngxDatatable: DatatableComponent;

  protected _onDestroy = new Subject<void>();

  public doctoCForm: FormGroup;
  lcto: FatDoctoC;

  isEditableParcela = {};
  parcelas: FinancRp[] = new Array;

  portadores: Portador[];

  filteredTipoCobrancas: ReplaySubject<TipoCobranca[]> = new ReplaySubject<TipoCobranca[]>(1);
  tipoCobrancas: TipoCobranca[];
  searching: boolean;
  public mobileParcelaSearch = '';
  public mobileParcelaSortBy: 'vcto' | 'valor' | 'parcela' = 'vcto';
  public mobileParcelaSortDir: 'asc' | 'desc' = 'asc';
  private parcelaReplaceArmedInputs = new WeakSet<HTMLInputElement>();
  condPgP: any;
  itemForm: any;
  saveParcelas = false;
  private pendingPosteriorUpdates: FormGroup[] = [];

  // @HostListener('window:keyup.esc') onKeyUp() {
  //   if (this.dialog.openDialogs.length > 0) {
  //     console.log('@HostListener(window:keyup.esc) onKeyUp()');
  //     this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
  //       .subscribe(res => {
  //         if (res) {
  //           this.dialogRef.close();
  //         }
  //       });
  //   }
  // }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoParcelasComponent>,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private portadorService: PortadorService,
    private tipoCobrancaService: TipoCobrancaService,
    private confirmService: AppConfirmService,
    // private cadastroFinancRpService: FinancRpService,
    private fatDoctoCService: FatDoctoCService,
    private financRpService: FinancRpService,
    public layout: LayoutService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    console.log('INIT Parc');
    this.doctoCForm = this.data.payload;
    this.lcto = this.doctoCForm.value;

    console.log(`Contem baixa : ${this.lcto.contemBaixa}`);


    this.portadorService.getPortadorPage(1,100).subscribe(val=>this.portadores = val.content);
    this.tipoCobrancaService.getTipoCobrancaPage(1,150).subscribe(val=>{
      this.tipoCobrancas = val.content;
      this.filteredTipoCobrancas.next( val.content);
    });
    this.fatDoctoCService.getFinancParcelas(this.lcto?.controle).subscribe(parcelas => {
      this.parcelas = parcelas.sort((a,b)=>(a.parcela??0) - (b?.parcela??0));
      this.reloadParcelaItens();
    })
  }

  ngAfterViewInit() {
    this.cdr.detectChanges();
    // Aguarda a renderização completa do diálogo
    setTimeout(() => {
      if (this.ngxDatatable) {
        this.ngxDatatable.recalculate();
        this.ngxDatatable.recalculateColumns();
        // Força um segundo recálculo após um pequeno delay para garantir que o layout esteja estabilizado
        setTimeout(() => {
          this.ngxDatatable.recalculate();
        }, 100);
      }
    }, 0);

    // Observador de redimensionamento para ajustar colunas dinamicamente
    this.dialogRef.afterOpened().subscribe(() => {
      const resizeObserver = new ResizeObserver(() => {
        if (this.ngxDatatable) {
          this.ngxDatatable.recalculate();
          this.ngxDatatable.recalculateColumns();
        }
      });
      resizeObserver.observe(document.querySelector('.mat-dialog-container') as Element);
      this._onDestroy.subscribe(() => resizeObserver.disconnect());
    });
  }

  // save parcela
  saveParcela(rowIndex: string | number, row: FormGroup) {
    const normalizedIndex = Number(rowIndex);
    const currentRowIndex = Number.isNaN(normalizedIndex) ? this.getParcelaRowIndex(row) : normalizedIndex;
    const shouldRecalculateVencimento = this.shouldRecalculateVencimento(row);

    if (shouldRecalculateVencimento) {
      if (!this.prepareParcelaForSave(currentRowIndex, row)) {
        return;
      }

      const emissao = moment(row.controls['emissao']?.value);
      const vcto = moment(row.controls['vcto']?.value);
      if (emissao.isValid() && vcto.isValid()) {
        const diasAtual = vcto.clone().startOf('day').diff(emissao.clone().startOf('day'), 'days');
        if (!this.applyJkawRecalcVencParcela(currentRowIndex, row, diasAtual)) {
          return;
        }
      }
    }

    const payload = this.buildParcelaPayload(row);

    this.isEditableParcela[rowIndex] = !this.isEditableParcela[rowIndex];
    this.runSaveAndRecalc(payload, `Salvando a parcela ${row.value.parcela}`, shouldRecalculateVencimento);
  }

  private shouldRecalculateVencimento(row: FormGroup): boolean {
    const diasDirty = !!row?.controls?.['dias']?.dirty;
    const vctoDirty = !!row?.controls?.['vcto']?.dirty;
    return diasDirty || vctoDirty;
  }

  private reloadParcelas(res: FinancRp[]) {
    this.parcelas = res.sort((a, b) => (a.parcela ?? 0) - (b?.parcela ?? 0));
    console.log(`salvo parcelas ${JSON.stringify(res)}`);
    this.reloadParcelaItens();
    this.saveParcelas = false;
  }

  changeDias(row: FormGroup) {
    console.log(`calculo ${moment(row.controls['emissao'].value).add(row.controls['dias'].value, 'days')}`);
    console.log(`dias:  ${row.controls['dias'].value}`);
    const diasAtual = Number(row.controls['dias']?.value ?? 0);

    const rowIndex = this.getParcelaRowIndex(row);
    if (!this.applyJkawRecalcVencParcela(rowIndex, row, diasAtual)) {
      return;
    }

    const payload = this.buildParcelaPayload(row);

    this.runSaveAndRecalc(payload, `Salvando a parcela ${row.value.parcela}`, true);
    this.isEditableParcela = {};

  }

  changeVcto(row: FormGroup) {
    const rowIndex = this.getParcelaRowIndex(row);
    const emissao = moment(row.controls['emissao']?.value);
    const vcto = moment(row.controls['vcto']?.value);
    if (!emissao.isValid() || !vcto.isValid()) {
      return;
    }

    const diasAtual = vcto.clone().startOf('day').diff(emissao.clone().startOf('day'), 'days');
    if (!this.applyJkawRecalcVencParcela(rowIndex, row, diasAtual)) {
      return;
    }

    const payload = this.buildParcelaPayload(row);

    this.runSaveAndRecalc(payload, `Salvando a parcela ${row.value.parcela}`, true);
    this.isEditableParcela = {};
  }

  private runSaveAndRecalc(payload: FinancRp, contextMessage: string, persistPosteriores: boolean): void {
    this.saveParcelas = true;
    const preSave$ = persistPosteriores ? this.persistPendingPosteriorUpdates() : of(null);

    preSave$
      .pipe(switchMap(() => this.fatDoctoCService.saveOrUpdateAndRecalcFinancParcelas(payload)))
      .subscribe(
        res => {
          this.reloadParcelas(res);
        },
        error => {
          this.saveParcelas = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO ${contextMessage} ... ${JSON.stringify(error.error)}`,
              error: true
            }
          );
        }
      );
  }

  private runSaveOnly(payload: FinancRp, contextMessage: string): void {
    this.saveParcelas = true;
    this.financRpService.saveOrUpdate(payload)
      .pipe(switchMap(() => this.fatDoctoCService.getFinancParcelas(this.lcto?.controle)))
      .subscribe(
        res => {
          this.reloadParcelas(res);
        },
        error => {
          this.saveParcelas = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO ${contextMessage} ... ${JSON.stringify(error.error)}`,
              error: true
            }
          );
        }
      );
  }

  private applyJkawRecalcVencParcela(rowIndex: number, row: FormGroup, diasAtual: number): boolean {
    const emissao = moment(row?.controls?.['emissao']?.value);
    if (!emissao.isValid() || !Number.isFinite(diasAtual)) {
      return false;
    }

    const vctoLocalDate = emissao.clone().startOf('day').add(diasAtual, 'days');

    if (rowIndex > 0) {
      const previousRow = this.parcelasFormArray?.at(rowIndex - 1) as FormGroup;
      const previousVcto = moment(previousRow?.controls?.['vcto']?.value);

      if (previousVcto.isValid() && previousVcto.isAfter(vctoLocalDate, 'day')) {
        this.confirmService.confirm(
          {
            message: 'A T E N Ç Ã O ! Não foi possível alterar! A data de vencimento desta parcela é menor que a parcela anterior. Verifique!',
            error: true
          }
        );
        return false;
      }
    }

    row.controls['vcto']?.setValue(vctoLocalDate.format('YYYY-MM-DD'), { emitEvent: false });
    row.controls['prorrogacao']?.setValue(vctoLocalDate.format('YYYY-MM-DD'), { emitEvent: false });
    row.controls['dias']?.setValue(diasAtual, { emitEvent: false });

    this.recalcPosteriorParcelasComDiaUtil(rowIndex, vctoLocalDate.clone());
    return true;
  }

  private getParcelaRowIndex(row: FormGroup): number {
    return (this.parcelasFormArray?.controls || []).indexOf(row);
  }

  private prepareParcelaForSave(rowIndex: string | number, row: FormGroup): boolean {
    if (!row) {
      return false;
    }

    const emissao = moment(row.controls['emissao']?.value);
    const diasControl = row.controls['dias'];
    const vctoControl = row.controls['vcto'];

    // Espelha a regra do desktop (recalcVencParcela):
    // quando editar por dias, o vencimento deve ser emissão + dias.
    if (emissao.isValid() && diasControl?.dirty && !vctoControl?.dirty) {
      const diasInformado = Number(diasControl.value ?? 0);
      if (Number.isFinite(diasInformado)) {
        vctoControl?.setValue(emissao.clone().add(diasInformado, 'days').format('YYYY-MM-DD'), { emitEvent: false });
      }
    }

    const vcto = moment(vctoControl?.value);

    if (!emissao.isValid() || !vcto.isValid()) {
      return true;
    }

    row.controls['dias']?.setValue(vcto.clone().startOf('day').diff(emissao.clone().startOf('day'), 'days'), { emitEvent: false });

    const normalizedIndex = Number(rowIndex);
    const currentRowIndex = Number.isNaN(normalizedIndex) ? this.getParcelaRowIndex(row) : normalizedIndex;

    if (!this.validateParcelaVencimentoSequence(currentRowIndex, row)) {
      return false;
    }

    this.recalcPosteriorParcelasComDiaUtil(currentRowIndex, vcto.clone());
    return true;
  }

  private recalcPosteriorParcelasComDiaUtil(rowIndex: number, baseVcto: moment.Moment): void {
    if (rowIndex < 0 || !baseVcto?.isValid()) {
      return;
    }

    const diaDoVencimento = baseVcto.date();
    const controls = this.parcelasFormArray?.controls || [];
    this.pendingPosteriorUpdates = [];

    for (let i = rowIndex + 1; i < controls.length; i++) {
      const parcelaRow = controls[i] as FormGroup;
      const currentVcto = moment(parcelaRow?.controls?.['vcto']?.value);
      if (!currentVcto.isValid()) {
        continue;
      }

      const ultimoDiaMes = currentVcto.daysInMonth();
      const diaAplicado = Math.min(diaDoVencimento, ultimoDiaMes);
      let novoVcto = currentVcto.clone().date(diaAplicado);

      if (novoVcto.day() === 6) {
        novoVcto = novoVcto.add(2, 'days');
      } else if (novoVcto.day() === 0) {
        novoVcto = novoVcto.add(1, 'days');
      }

      const oldVctoText = moment(parcelaRow.controls['vcto']?.value).isValid()
        ? moment(parcelaRow.controls['vcto']?.value).format('YYYY-MM-DD')
        : '';
      const newVctoText = novoVcto.format('YYYY-MM-DD');

      parcelaRow.controls['vcto']?.setValue(newVctoText, { emitEvent: false });

      const emissao = moment(parcelaRow.controls['emissao']?.value);
      if (emissao.isValid()) {
        const novoDias = novoVcto.clone().startOf('day').diff(emissao.startOf('day'), 'days');
        const oldDias = Number(parcelaRow.controls['dias']?.value ?? 0);
        parcelaRow.controls['dias']?.setValue(
          novoDias,
          { emitEvent: false }
        );

        if (oldVctoText !== newVctoText || oldDias !== novoDias) {
          this.pendingPosteriorUpdates.push(parcelaRow);
        }
      }
    }
  }

  private persistPendingPosteriorUpdates(): Observable<any> {
    const updates = (this.pendingPosteriorUpdates || [])
      .map(row => this.buildParcelaPayload(row))
      .filter(payload => !!payload?.uuid);

    this.pendingPosteriorUpdates = [];

    if (!updates.length) {
      return of(null);
    }

    return forkJoin(updates.map(payload => this.financRpService.saveOrUpdate(payload)));
  }

  private buildParcelaPayload(row: FormGroup): FinancRp {
    const payload = { ...row.value } as any;
    payload.emissao = this.toDateForApi(payload.emissao);
    payload.vcto = this.toDateForApi(payload.vcto);
    payload.prorrogacao = payload.vcto;
    return payload as FinancRp;
  }

  private toDateForApi(value: any): any {
    if (!value) {
      return value;
    }
    if (value instanceof Date) {
      return value;
    }

    const parsed = moment(value, ['YYYY-MM-DD', 'DD/MM/YYYY', moment.ISO_8601], true);
    if (parsed.isValid()) {
      return parsed.startOf('day').toDate();
    }

    const fallback = moment(value);
    return fallback.isValid() ? fallback.startOf('day').toDate() : value;
  }

  private validateParcelaVencimentoSequence(rowIndex: number, row: FormGroup): boolean {
    if (rowIndex <= 0) {
      return true;
    }

    const previousRow = this.parcelasFormArray?.at(rowIndex - 1) as FormGroup;
    const previousVcto = moment(previousRow?.controls?.['vcto']?.value);
    const currentVcto = moment(row?.controls?.['vcto']?.value);

    if (!previousVcto.isValid() || !currentVcto.isValid()) {
      return true;
    }

    if (currentVcto.isBefore(previousVcto, 'day')) {
      this.confirmService.confirm(
        {
          message: 'A T E N Ç Ã O ! Não foi possível alterar! A data de vencimento desta parcela é menor que a parcela anterior. Verifique!',
          error: true
        }
      );
      return false;
    }

    return true;
  }

  reloadParcelaItens() {
    this.doctoCForm.setControl('financRps', this.fb.array([]));
    this.parcelas?.forEach(parcela => {
      this.addParcela(parcela);
    });
    this.doctoCForm.setControl('financRps', this.parcelasFormArray);
  }

  addParcela(rp: FinancRp) {
    this.parcelasFormArray.push(
      this.newFbGroup(rp)
    );
  }

  private newFbGroup(rp: FinancRp) {
    const fbGroup = this.fb.group({
      id: [rp.id],
      codigo: [rp.codigo],
      cadastro: [rp.cadastro],
      carencia: [rp.carencia],
      dataref: [rp.dataref],
      descAte: [rp.descAte],
      descValor: [rp.descValor],
      desconto: [rp.desconto],
      docto: [rp.docto],
      emissao: [rp.emissao],
      dias: [rp.dias],
      vcto: [rp.vcto],
      fatura: [rp.fatura],
      moedaId: [rp.moedaId],
      natureza: [rp.natureza],
      nossonumero: [rp.nossonumero],
      numeroboleto: [rp.numeroboleto],
      parcela: [rp.parcela],
      perAcrescimo: [rp.perAcrescimo],
      perJurosmora: [rp.perJurosmora],
      perMulta: [rp.perMulta],
      prorrogacao: [rp.prorrogacao],
      statusReg: [rp.statusReg],
      valorAcrescimo: [rp.valorAcrescimo],
      valorDesconto: [rp.valorDesconto],
      valorJurosmora: [rp.valorJurosmora],
      valorSaldo: [rp.valorSaldo],
      valorTotal: [rp.valorTotal],
      vendedorId: [rp.vendedorId],
      vendedorUUID: [rp.vendedorUUID],
      fatCondPgP: [rp.fatCondPgP],
      uuid: [rp.uuid],
      portadorId: [rp.portadorId],
      tipoCobranca: [rp.tipoCobranca],
      searchPortador: [''],
      searchTipoCobranca: [''],
    });

    fbGroup.get('searchPortador')?.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.searching = true),
        switchMap(value => {
          const search = (value ?? '').toString().trim();
          return search.length > 0
            ? this.portadorService.getPortadorPageSearch(1, 10, search)
            : this.portadorService.getPortadorPage(1, 100);
        }),
        takeUntil(this._onDestroy)
      )
      .subscribe(
        portadores => {
          this.portadores = portadores.content || [];
          this.searching = false;
        },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO PORTADOR ... ${error}`,
              error: true
            }
          );
        }
      );

    /**
     * Search Tipo Cobranca
     */

    // fbGroup.get('searchTipoCobranca').valueChanges
    // .pipe(
    //   debounceTime(500),
    //   tap(() => this.searching = true),
    //   switchMap(value => ((typeof (value) === 'string') ?
    //     (value !== undefined && value !== '' ? this.tipoCobrancaService.getTipoCobrancaPageSearch(1, 10, value) :
    //       this.tipoCobrancaService.getTipoCobrancaPage(1, 10)) : new Observable<PageResult<TipoCobranca>>())
    //     .pipe(
    //       finalize(() => this.searching = false),
    //     )
    //   )
    // )
    // .subscribe(tipos => {
    //   this.tipoCobrancas = tipos.content;
    //   if (this.condPgP.financTipoCobranca !== undefined && this.condPgP.financTipoCobranca !== null) {
    //     if (this.tipoCobrancas.map(n => n.id).includes(this.condPgP.financTipoCobranca.id)) {
    //       const financTipoCobranca = this.tipoCobrancas.find(n => n.id === this.condPgP.financTipoCobranca.id) ?? this.condPgP.financTipoCobranca;
    //       if (financTipoCobranca !== null && financTipoCobranca !== undefined) {
    //         this.itemForm.controls['financTipoCobranca'].setValue(financTipoCobranca);
    //       }
    //     } else {
    //       this.tipoCobrancas.push(this.condPgP.financTipoCobranca);
    //     }
    //   }
    // });



    fbGroup.get('searchTipoCobranca')?.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.searching = true),
        switchMap(value => {
          const search = (value ?? '').toString().trim();
          return search.length > 0
            ? this.tipoCobrancaService.getTipoCobrancaPageSearch(1, 10, search)
            : this.tipoCobrancaService.getTipoCobrancaPage(1, 100);
        }),
        takeUntil(this._onDestroy)
      )
      .subscribe(
        (tipos: PageResult<TipoCobranca>) => {
          this.tipoCobrancas = tipos.content || [];
          this.filteredTipoCobrancas.next(this.tipoCobrancas.slice());
          this.searching = false;
        },
        error => {
          this.searching = false;
          this.confirmService.confirm(
            {
              message: `A T E N Ç Ã O !  ERRO PESQUISANDO TIPO DE COBRANÇA ... ${error}`,
              error: true
            }
          );
        }
      );


    return fbGroup;
  }

  get parcelasFormArray(): FormArray {
    return this.doctoCForm.get('financRps') as FormArray;
  }

  toggleMobileParcelaSortDir() {
    this.mobileParcelaSortDir = this.mobileParcelaSortDir === 'asc' ? 'desc' : 'asc';
  }

  compareById = (a: any, b: any): boolean => {
    if (a === b) {
      return true;
    }
    if (!a || !b) {
      return false;
    }
    return a.id === b.id;
  };

  openNativeDatePicker(input: HTMLInputElement) {
    if (!input) {
      return;
    }
    const picker = input as any;
    if (typeof picker.showPicker === 'function') {
      picker.showPicker();
      return;
    }
    input.focus();
  }

  isMobileQuickEditOpen(index: number): boolean {
    return !!this.isEditableParcela[index];
  }

  toggleMobileQuickEdit(index: number) {
    const alreadyOpen = !!this.isEditableParcela[index];
    // Mantem somente um editor rapido aberto por vez para reduzir
    // "remontagem" visual e melhorar o aproveitamento de tela.
    this.isEditableParcela = {};
    if (!alreadyOpen) {
      const row = this.parcelasFormArray?.at(index) as FormGroup;
      if (row?.controls?.['vcto']) {
        const rawVcto = row.controls['vcto'].value;
        const normalizedVcto = this.normalizeDateForInput(rawVcto);
        if (normalizedVcto) {
          row.controls['vcto'].setValue(normalizedVcto, { emitEvent: false });
        }
      }
      this.isEditableParcela[index] = true;
    }
  }

  private normalizeDateForInput(rawDate: any): string {
    if (!rawDate) {
      return '';
    }

    const m = moment(rawDate);
    if (m.isValid()) {
      return m.format('YYYY-MM-DD');
    }

    const text = String(rawDate).trim();
    // fallback simples para datas no formato dd/MM/yyyy
    const parts = text.split('/');
    if (parts.length === 3) {
      const [dd, mm, yyyy] = parts;
      if (yyyy?.length === 4) {
        return `${yyyy}-${mm.padStart(2, '0')}-${dd.padStart(2, '0')}`;
      }
    }

    return '';
  }

  getMobileParcelaRows(): Array<{ row: any; originalIndex: number }> {
    const rows = (this.parcelasFormArray?.controls || []).map((row, originalIndex) => ({ row, originalIndex }));
    const search = (this.mobileParcelaSearch || '').toString().toLowerCase().trim();

    const filtered = !search
      ? rows
      : rows.filter((item) => {
        const value = item.row?.value || {};
        const docto = `${value?.docto || ''}`.toLowerCase();
        const parcela = `${value?.parcela || ''}`.toLowerCase();
        const tipo = `${value?.tipoCobranca?.codigo || ''} ${value?.tipoCobranca?.descricao || ''}`.toLowerCase();
        const portador = `${value?.portadorId?.codigo || ''} ${value?.portadorId?.descricao || ''}`.toLowerCase();
        return docto.includes(search) || parcela.includes(search) || tipo.includes(search) || portador.includes(search);
      });

    return filtered.sort((a, b) => {
      const av = a.row?.value || {};
      const bv = b.row?.value || {};
      let result = 0;

      if (this.mobileParcelaSortBy === 'valor') {
        result = Number(av?.valorTotal || 0) - Number(bv?.valorTotal || 0);
      } else if (this.mobileParcelaSortBy === 'parcela') {
        result = Number(av?.parcela || 0) - Number(bv?.parcela || 0);
      } else {
        const ad = av?.vcto ? new Date(av.vcto).getTime() : 0;
        const bd = bv?.vcto ? new Date(bv.vcto).getTime() : 0;
        result = ad - bd;
      }

      return this.mobileParcelaSortDir === 'asc' ? result : -result;
    });
  }

  trackByMobileParcelaIndex(_i: number, item: { row: any; originalIndex: number }): number {
    return item?.originalIndex ?? _i;
  }

  armParcelaValueReplace(event: FocusEvent) {
    const input = event.target as HTMLInputElement | null;
    if (!input) {
      return;
    }

    if (this.layout?.isMobile) {
      this.parcelaReplaceArmedInputs.add(input);
    }

    setTimeout(() => {
      input.select();
    }, 0);
  }

  applyParcelaValueReplaceOnFirstKey(event: KeyboardEvent, row: FormGroup, controlName: 'valorTotal') {
    if (!this.layout?.isMobile) {
      return;
    }

    const input = event.target as HTMLInputElement | null;
    if (!input || !this.parcelaReplaceArmedInputs.has(input)) {
      return;
    }

    const key = event.key;
    const isPrintable = key.length === 1;
    const isDelete = key === 'Backspace' || key === 'Delete';
    if (!isPrintable && !isDelete) {
      return;
    }

    row.controls[controlName].setValue('');
    this.parcelaReplaceArmedInputs.delete(input);
  }

  disarmParcelaValueReplace(event: FocusEvent) {
    const input = event.target as HTMLInputElement | null;
    if (!input) {
      return;
    }
    this.parcelaReplaceArmedInputs.delete(input);
  }


  editParcela(row: any, displayIndex?: number) {
    console.log('editDoctoI', row);
    const parcelaDisplay = (typeof displayIndex === 'number' ? displayIndex : 0) + 1;
    const title = `PARCELA #${parcelaDisplay}: [  ${row?.docto} ]`;
    const dialogRef: MatDialogRef<any> = this.dialog.open(FinancRpPopupComponent, {
      width: this.layout.isMobile ? '100vw' : '98%',
      maxWidth: '100vw',
      height: this.layout.isMobile ? '100dvh' : '90vh',
      maxHeight: '100dvh',
      disableClose: true,
      panelClass: 'custom-dialog-class',
      autoFocus: false,
      restoreFocus: false,
      data: { title: title, payload: row }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }

        // Mantem a mesma logica do datatable: ao editar uma parcela,
        // recalcula as parcelas subsequentes e recarrega a lista inteira.
        this.runSaveAndRecalc(res, 'Salvando/Recalculando parcela', false);
      })
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  getDialogTitle(): string {
    return 'Desdobramento de Parcelas';
  }

  getDialogCliente(): string {
    const payloadValue = this.data?.payload?.value || {};
    return (payloadValue?.nome || payloadValue?.cadastro?.nomeFantasia || payloadValue?.cadastro?.razaoSocial || '').toString().trim();
  }

  getDialogControle(): string {
    const payloadValue = this.data?.payload?.value || {};
    const controle = payloadValue?.controle;
    if (controle === null || controle === undefined || `${controle}`.trim() === '') {
      return '';
    }
    const controleNum = Number(controle);
    if (!isNaN(controleNum)) {
      return controleNum.toString().padStart(10, '0');
    }
    return `${controle}`;
  }

  close() {
    this.dialogRef.close();
    // this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
    //   .subscribe(res => {
    //     if (res) {
    //       this.dialogRef.close();
    //     }
    //   });
  }

}


